import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import HealingFieldBehavior from "../../HealingFieldBehavior";
import Player from "../../Player";

export default class HealingField extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 15,
            duration: 5,
            energyCost: 25,
            icon: 12,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyUp,
            info: `Healing Field (15s cooldown) - Heals teammates in a 256U radius 50HP per second for 5 seconds`
        })
    }

    onUse(): void {
        const [, field] = this.player.engine.NewGameObjectWithScript<HealingFieldBehavior>(HealingFieldBehavior);
        field.transform.position = this.player.transform.position;
        field.team = this.player.team;
        field.lifetime = this.duration;

        this.player.engine.sendCreatePacket(field.gameObject, {
            type: "HEALING_FIELD",
            values: [
                {
                    key: "team",
                    value: field.team || "",
                    type: PacketValueSerialType.String
                },
                {
                    key: "lifetime",
                    value: field.lifetime,
                    type: PacketValueSerialType.Byte
                }
            ]
        });
    }

    onKeydownDraw(): void {
        this.player.ctx.fillStyle = '#55ff5530';
        this.player.engine.FillCircle(this.player.transform.position, 256);
    }
}